import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { BannerImage1, BannerImage2, BannerImage3, BannerImage4 } from "../../../Data/image";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";

const Banner = () => {
  const images = [BannerImage1, BannerImage2, BannerImage3, BannerImage4];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        textAlign: "center",
        width: "100%",
        maxWidth: "100vw",
        overflow: "hidden",
        marginBottom: isMobile ? "20px" : "50px", // Reduced margin for mobile
        borderRadius: "12px",
        boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)",
      }}
    >
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        loop={true}
        speed={1200}
        navigation={{
          nextEl: ".custom-next",
          prevEl: ".custom-prev",
        }}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: isMobile ? "30vh" : "80vh", // Reduced from 50vh to 30vh for mobile
                background: `url(${image}) center/cover no-repeat`,
                borderRadius: "12px",
                animation: "moveUpDown 4s ease-in-out infinite",
              }}
            >
              {/* Overlay for better readability */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2))",
                  borderRadius: "12px",
                }}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Buttons */}
      <Box
        className="custom-prev"
        sx={{
          position: "absolute",
          top: "50%",
          left: isMobile ? "10px" : "20px", // Reduced left offset for mobile
          transform: "translateY(-50%)",
          zIndex: 10,
          cursor: "pointer",
          color: "white",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          borderRadius: "50%",
          width: isMobile ? "35px" : "50px", // Slightly smaller buttons for mobile
          height: isMobile ? "35px" : "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "0.3s ease",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            transform: "translateY(-50%) scale(1.1)", // Adjusted transform for consistency
          },
        }}
      >
        <ArrowBackIosNew fontSize={isMobile ? "small" : "medium"} />
      </Box>

      <Box
        className="custom-next"
        sx={{
          position: "absolute",
          top: "50%",
          right: isMobile ? "10px" : "20px", // Reduced right offset for mobile
          transform: "translateY(-50%)",
          zIndex: 10,
          cursor: "pointer",
          color: "white",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          borderRadius: "50%",
          width: isMobile ? "35px" : "50px", // Slightly smaller buttons for mobile
          height: isMobile ? "35px" : "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "0.3s ease",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            transform: "translateY(-50%) scale(1.1)", // Adjusted transform for consistency
          },
        }}
      >
        <ArrowForwardIos fontSize={isMobile ? "small" : "medium"} />
      </Box>

      {/* Add keyframe animation for slight movement */}
      <style>
        {`
          @keyframes moveUpDown {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(${isMobile ? "-5px" : "-10px"}); // Reduced animation range for mobile
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Banner;